import { AppThunk } from "@Store/index";
import fetchHomePageData from "./fetchHomePageData";

const loadData = (props: any): AppThunk[] => [
  fetchHomePageData(props),
  // More pre-fetched actions...
];

export default loadData;
